const element = document.getElementById('portal-server-settings');
let serverSettings;

if (element) {
  serverSettings = JSON.parse(element.textContent || '');
}

const domain =
  serverSettings?.auth0?.domain ||
  (import.meta.env.VITE_AUTH0_DOMAIN as string);
const clientId =
  serverSettings?.auth0?.clientId ||
  (import.meta.env.VITE_AUTH0_CLIENT_ID as string);
const audience =
  serverSettings?.auth0?.audience ||
  (import.meta.env.VITE_AUTH0_AUDIENCE as string);

export const env =
  serverSettings?.env ||
  (import.meta.env.VITE_ENV as string) ||
  (process.env.NODE_ENV === 'test' ? 'test' : 'dev');

export const isNonProd = ['staging', 'dev', 'qa'].includes(
  env?.toLowerCase() as string,
);

export const hostnames = {
  localhost: 'localhost',
  internal: 'portal.internal',
  dev: 'portal-dev.sitecore-staging.cloud',
  qa: 'portal-qa.sitecore-staging.cloud',
  staging: 'portal-staging.sitecore-staging.cloud',
  beta: 'portal-beta.sitecorecloud.io',
  'pre-production': 'portal-preprod.sitecorecloud.io',
  production: 'portal.sitecorecloud.io',
};

export const marketplaceSystemIds = {
  [hostnames.internal]: 'cf6dff19-052b-4482-8200-7dea7f4bd04e',
  [hostnames.localhost]: 'cf6dff19-052b-4482-8200-7dea7f4bd04e',
  [hostnames.dev]: 'cf6dff19-052b-4482-8200-7dea7f4bd04e',
  [hostnames.qa]: 'cf6dff19-052b-4482-8200-7dea7f4bd04e',
  [hostnames.staging]: 'cf6dff19-052b-4482-8200-7dea7f4bd04e',
  [hostnames.beta]: 'a179aa11-40a9-45ce-b8c7-a8722a916691',
  [hostnames['pre-production']]: 'a179aa11-40a9-45ce-b8c7-a8722a916691',
  [hostnames.production]: '5c01153f-464a-464d-b691-23c131bf73f0',
};
export const isMarketplaceApp = (systemId: string | null | undefined) => {
  return systemId === marketplaceSystemIds[window.location.hostname];
};

export function getSnowBaseUrl() {
  const lowerCaseEnv = env?.toLowerCase() as string;

  const snowBaseUrl = {
    dev: 'https://sitecoredev.service-now.com/api/scas/v1',
    staging: 'https://sitecoredev.service-now.com/api/scas/v1',
    'pre-production': 'https://sitecoretest.service-now.com/api/scas/v1',
    production: 'https://sitecore.service-now.com/api/scas/v1',
  }[lowerCaseEnv];

  // NOTICE: will always point to dev until snow side will deploy to the rest scale units
  return snowBaseUrl || 'https://sitecoredev.service-now.com/api/scas/v1';
}

export function getFeatureFlagBaseUrl() {
  const featureFlagBaseUrl = {
    [hostnames.localhost]:
      'https://featureflags-staging.sitecore-staging.cloud/api/featureflags/v1',
    [hostnames.internal]:
      'https://featureflags-staging.sitecore-staging.cloud/api/featureflags/v1',
    [hostnames.dev]:
      'https://featureflags-dev.sitecore-staging.cloud/api/featureflags/v2',
    [hostnames.qa]:
      'https://featureflags-qa.sitecore-staging.cloud/api/featureflags/v1',
    [hostnames.staging]:
      'https://featureflags-staging.sitecore-staging.cloud/api/featureflags/v1',
    [hostnames.beta]:
      'https://featureflags-beta.sitecorecloud.io/api/featureflags/v1',
    [hostnames['pre-production']]:
      'https://featureflags-beta.sitecorecloud.io/api/featureflags/v1',
    [hostnames.production]:
      'https://featureflags.sitecorecloud.io/api/featureflags/v1',
  }[window.location.hostname];

  return featureFlagBaseUrl || '';
}

/**
 * Service to send apm events from this app to.
 * Setting this url also enables APM.
 */
export const apmServerUrl: string =
  (window as any)?.VITE_APM_SERVER_URL || import.meta.env.VITE_APM_SERVER_URL;

/**
 * The label this app appears in APM with, in the list of services.
 * Allowed characters: a-z, A-Z, 0-9, -, _, and space.
 * Optional. Defaults to 'Sitecore cloud Portal UI'.
 */
export const apmServiceName: string =
  (window as any)?.VITE_APM_SERVICE_NAME ||
  import.meta.env.VITE_APM_SERVICE_NAME ||
  'Sitecore Cloud Portal UI';

export const getAuthSettings = () => {
  return { domain, clientId, audience };
};

export const earlyAccessConfig: { orgIds: string[]; orgTypes: string[] } = {
  orgIds: [],
  orgTypes: [],
};
